import React, { useState } from 'react';
import { Container, Col, Row, Table, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { ordenanzas } from '@/api/gobiernoAbiertoApi';
import './OrdenanzasView.css';
import { Download } from 'react-bootstrap-icons';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import Loader from '../components/Loader/Loader';

const OrdenanzasView = () => {
  const [loading, setLoading] = useState();
  const [form, setForm] = useState({ estado: '-1', numero: null, anio: null, pattern: null });
  const { estado, numero, anio, pattern } = form;
  const [list, setList] = useState(null);
  const onChange = (_event) => {
    setForm({ ...form, [_event.currentTarget.id]: _event.currentTarget.value });
  };
  const onBuscarClicked = () => {
    let request = {
      estado: estado,
      numero: numero,
      anio: anio,
      pattern: pattern,
    };
    setLoading(true);
    ordenanzas(request)
      .then((response) => {
        let result = JSON.parse(response.data);
        setList(result);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  let urlDescargar = 'https://transferenciasmvla.com.ar/mvlaApi/Ordenanzas/?idOrdenanza=';

  const estados = [
    { value: '1', label: 'Clasificando' },
    { value: '2', label: 'Aprobada/Vigente' },
    { value: '3', label: 'Derogada' },
    { value: '4', label: 'Vetada' },
    { value: '9', label: 'Anulada' },
  ];

  const getEstado = (valor) => {
    let estadoSeleccionado = estados.filter((i) => i.value == valor);
    if (estadoSeleccionado && estadoSeleccionado.length > 0)
      return estados.filter((i) => i.value == valor)[0].label;
    return 'Desconocido';
  };

  return (
    <>
      <MunicipalidadHeader tipo="Ciudadano" title="Consulta de Ordenanzas"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <Loader loading={loading}></Loader>
        <Row className="first-row">
          <Col>
            <Form.Label htmlFor="estado">Estado</Form.Label>
            <Form.Select
              aria-label="Default select example"
              id="estado"
              onChange={onChange}
              value={estado}
            >
              <option value="-1">Todos</option>
              <option value="2">Aprobada/Vigente</option>
              <option value="3">Derogada</option>
              <option value="1">Clasificando</option>
              <option value="4">Vetada</option>
              <option value="9">Anulada</option>
            </Form.Select>
          </Col>
          <Col>
            <Form.Label htmlFor="numero">Numero</Form.Label>
            <Form.Control type="text" id="numero" onChange={onChange} value={numero} />
          </Col>
          <Col>
            <Form.Label htmlFor="anio">Año</Form.Label>
            <Form.Control type="text" id="anio" onChange={onChange} value={anio} />
          </Col>
          <Col xs={12} sm={12} md={4} lg={4} className="descripcion">
            <Form.Label htmlFor="pattern">Buscar en la descripción</Form.Label>
            <Form.Control type="text" id="pattern" onChange={onChange} value={pattern} />
          </Col>
          <Col>
            <Button className="buscar" onClick={onBuscarClicked} variant="primary">
              Buscar
            </Button>
          </Col>
        </Row>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Estado</th>
              <th>Número</th>
              <th>Año</th>
              <th className="hide-mobile" style={{ width: '130px' }}>
                Fecha Emisión
              </th>
              <th className="hide-mobile">Descripcion</th>
              <th className="hide-mobile">Expediente</th>
              <th className="hide-mobile">Modificatoria</th>
              <th>Descargar</th>
            </tr>
          </thead>
          <tbody>
            {list !== null &&
              list.length > 0 &&
              list.map((item, idx) => (
                <tr key={idx}>
                  <td>{getEstado(item.Estado)}</td>
                  <td>{item.Numero}</td>
                  <td>{item.Anio}</td>
                  <td className="hide-mobile">{item.FechaEmision.substring(0, 10)}</td>
                  <td className="hide-mobile">{item.Descripcion}</td>
                  <td className="hide-mobile">{item.Expediente}</td>
                  <td className="hide-mobile">{item.ModificatoriaDe}</td>
                  <td>
                    <a href={urlDescargar + item.ID} rel="noreferrer" target="_blank">
                      <Download />
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default React.memo(OrdenanzasView);
